/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { LocalisationService } from '@myprofile-ui/myprofile-localisation-api'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { v4 as uuid } from 'uuid'
import { PhoneCommunicationDto } from '../../../../../apps/myprofile-ui/src/app/services/phone/phone.service'

@Injectable({
  providedIn: 'root',
})
export class MyProfilePhoneService {
  private localisationService = inject(LocalisationService)
  public getTranslations(country: string, locale: string): Observable<any> {
    return this.localisationService
      .getTranslationFor('shared-webcomponents', country, locale)
      .pipe(map((translations) => ({ translations })))
  }
}
